(() => {
  'use strict';
  const PDP_PATH = '/products/thalpea-period-heat-patches';
  const ALLOWED_PARAMS = ['utm_source', 'utm_campaign', 'utm_content', 'utm_medium', 'utm_term', 'utm_id', 'fbclid'];
  const incoming = new URLSearchParams(window.location.search);
  document.querySelectorAll('a[href]').forEach(anchor => {
    let destination;
    try { destination = new URL(anchor.getAttribute('href'), window.location.href); } catch (_) { return; }
    if (destination.protocol !== 'https:' || destination.hostname !== 'thalpea.com' || destination.port ||
        destination.username || destination.password || destination.pathname !== PDP_PATH) return;
    let changed = false;
    ALLOWED_PARAMS.forEach(key => {
      const values = incoming.getAll(key);
      if (values.length) {
        destination.searchParams.set(key, values[values.length - 1]);
        changed = true;
      }
    });
    if (changed) anchor.setAttribute('href', destination.href);
  });
  // Only reopen Shopify's existing configured consent UI. Never grant consent,
  // load another CMP, initialize a pixel, or send an analytics event here.
  document.querySelectorAll('[data-cookie-settings]').forEach(button => {
    button.addEventListener('click', () => {
      const status = document.getElementById('thalpea-privacy-status');
      const unavailable = () => { if (status) status.hidden = false; };
      const nativeBanner = window.privacyBanner;
      if (!nativeBanner || typeof nativeBanner.showPreferences !== 'function') { unavailable(); return; }
      if (status) status.hidden = true;
      try {
        Promise.resolve(nativeBanner.showPreferences()).catch(unavailable);
      } catch (_) { unavailable(); }
    });
  });
})();
